import { Five9SurveyConfig } from "./five9-typings";

export const defaultSurveyConfig: Five9SurveyConfig = {
  vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137787/new_ivr_session',
  sccTenantName: 'Young Living Essential Oils',
}
